import theme from '@/styles/theme';

interface Props {
  color?: string;
}

const AgreementCheck = ({ color = theme.color.gray100 }: Props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <mask id='mask0_2549_19679' maskUnits='userSpaceOnUse' x='0' y='0' width='20' height='20'>
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_2549_19679)'>
        <path
          d='M7.95838 12.2245L14.8089 5.37394C15.0305 5.15232 15.2932 5.0415 15.597 5.0415C15.9007 5.0415 16.1634 5.15232 16.385 5.37394C16.6066 5.59557 16.7174 5.85825 16.7174 6.162C16.7174 6.46574 16.6066 6.72842 16.385 6.95005L8.7419 14.5932C8.52027 14.8148 8.2591 14.9256 7.95838 14.9256C7.65766 14.9256 7.39648 14.8148 7.17486 14.5932L3.61507 11.0334C3.39345 10.8118 3.28416 10.5491 3.28717 10.2453C3.29018 9.94159 3.4025 9.6789 3.62413 9.45727C3.84575 9.23565 4.10844 9.12484 4.41219 9.12484C4.71593 9.12484 4.97861 9.23565 5.20023 9.45727L7.95838 12.2245Z'
          fill={color}
        />
      </g>
    </svg>
  );
};

export default AgreementCheck;
